import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UploadService } from '../../../../../service/upload.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-edit-html-image',
    standalone: false,
    templateUrl: './edit-html-image.component.html',
    styleUrl: './edit-html-image.component.scss'
})
export class EditHtmlImageComponent implements OnInit {
    data = inject(MAT_DIALOG_DATA);
    dialogRef = inject(MatDialogRef<EditHtmlImageComponent>);
    uploadService = inject(UploadService);
    private destroyRef = inject(DestroyRef);

    isLoading: boolean = false;
    errorText: string = '';
    newFile: File | null = null;
    imageSrc: string | ArrayBuffer | null = this.data.image as string;

    ngOnInit(): void {
        this.dialogRef.keydownEvents()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: event => {
                    if (event.key === 'Escape') {
                        event.preventDefault();
                        this.close();
                    } else if (event.key === 'Enter' && this.newFile) {
                        event.preventDefault();
                        this.saveNewImage();
                    }
                },
            });
    }

    onFileSelected(event: any) {
        this.errorText = '';
        const file: File = event.target.files[0];
        if (file.size > 2 * 1024 * 1024) {
            this.errorText = 'File size exceeds 2MB limit.';
            return;
        }
        if (file && file.type.startsWith('image/')) {
            this.newFile = file;

            const reader = new FileReader();
            reader.onload = e => {
                this.imageSrc = reader.result;
            };
            reader.readAsDataURL(file);
        } else {
            this.imageSrc = this.data.image;
            this.errorText = 'Please select a valid image file.';
        }

    }
    close() {
        this.dialogRef.close();
    }
    async saveNewImage() {
        if (this.newFile) {
            this.isLoading = true;
            let fileId = undefined
            if (this.data.image.indexOf("user_closing_img_") !== -1) {
                fileId = this.data.image;
            }
            let result = await this.uploadService.uploadForHtmlClosings(this.newFile, this.data.streamId, this.data.stepId, fileId);
            this.isLoading = false;
            if (result === false) {
                return;
            }
            let imageUrl = this.data.image.split('/').pop() as string;
            this.dialogRef.close({
                oldImageUrl: this.data.image,
                newImageUrl: this.data.image.replace(imageUrl, result)
            });
        }
    }
}

